var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:`${ _vm.capitalize ? 'text-capitalize' : ''} button-orientation ${ _vm.round ? 'round' : ''}`,attrs:{"depressed":"","color":_vm.corPrincipal,"rounded":_vm.rounded}},'v-btn',_vm.settings,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }